
import { IRule } from '../rules/rule';
import { CustomerOrderReferenceRule } from '../rules/customer-order-reference.rule';
import { CurrentOrder } from '../../models/current-order.model';
import { ValidationResultErrorMessage } from '../models/validation-result-error-message.model';
import { OrderAdditionalFieldsRule } from '../rules/order-additional-fields.rule';
import { Recipient } from '../../models/recipient.model';
import { OrderRecipientsRule } from '../rules/order-recipients.rule';
import { OrderValidationResult } from '../models/order-validation-result.model';

export class AdditionalOrderDetailsValidator {

    order: CurrentOrder;
    rules: IRule[] = [];
    nimsRecipients: Recipient[];

    constructor(order: CurrentOrder, recipients: Recipient[]) {
        this.nimsRecipients = recipients;
        this.order = order;
        this.initializeRules();
    }

    initializeRules() {
        this.rules.push(new CustomerOrderReferenceRule(this.order));
        this.rules.push(new OrderAdditionalFieldsRule(this.order));
        this.rules.push(new OrderRecipientsRule(this.order, this.nimsRecipients));
    }

    async validate(): Promise<OrderValidationResult> {
        const msgs: ValidationResultErrorMessage[] = [];
        let response: OrderValidationResult = {
            isValid: true
        };
        const invalidAfCodes: string[] = [];
        const newAfs: any[] = [];
        const invalidRecipientCodes: string[] = [];
        const newRecipients: any[] = [];
        for (const rule of this.rules) {
            response = await rule.validate();
            if (!response.isValid) {
                msgs.push(response.errorMessage);
            }
            if (response.invalidRecipientCodes && response.invalidRecipientCodes.length > 0) {
                invalidRecipientCodes.push(...response.invalidRecipientCodes);
            }
            if (response.invalidAfCodes && response.invalidAfCodes.length > 0) {
                invalidAfCodes.push(...response.invalidAfCodes);
            }
            if (response.newOrderAfCodes && response.newOrderAfCodes.length > 0) {
                newAfs.push(...response.newOrderAfCodes);
            }
            if (response.newRecipients && response.newRecipients.length > 0) {
                newRecipients.push(...response.newRecipients);
            }
        }
        response.invalidAfCodes = invalidAfCodes;
        response.invalidRecipientCodes = invalidRecipientCodes;
        response.newOrderAfCodes = newAfs;
        response.newRecipients = newRecipients;
        response.errorMessages = msgs;
        response.isValid = msgs.length === 0;
        return response;
    }

}
